export type VuetifyFieldValidationRuleCallback = (
  value: string
) => boolean | string;
export type VuetifyFieldValidationRules = VuetifyFieldValidationRuleCallback[];

export const SALES_ARTICLES = [
  {
    media_id: "R9lAXiMOFA8wYez87YPRmXc0OISqDXAZ3-92FbXMIkY",
    content: {
      news_item: [
        {
          title: "Sale Alert // 近期促销汇总（6月30日）",
          author: "",
          digest: "",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000512&idx=1&sn=894defe0b91e8475beae752fb11c3bdc&chksm=6878b1ca5f0f38dcf0f093a93d3ebbc862697aa7f1054941b98694367a6c271268601e030ab3#rd",
          thumb_url: "31.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmQ_loEsbKgtEs64sLT9w_rc",
    content: {
      news_item: [
        {
          title: "Sale Alert // 近期促销汇总（6月23日）",
          author: "",
          digest: "",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000507&idx=1&sn=d10e9b8798c10ff719437ae93ca01ad7&chksm=6878b0315f0f39273ae371ec1c8a62bd56e3dd08c6176a82f792b254bc1cb470955af43cf364#rd",
          thumb_url: "30.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmS-QIj5G_Jay0PGVc5mbupY",
    content: {
      news_item: [
        {
          title: "Sale Alert // 近期促销汇总（6月16日）",
          author: "",
          digest: "",

          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000501&idx=1&sn=9d22f6326a6e5ff7515582b4e82dee02&chksm=6878b03f5f0f39290efbfa95183b5e86d33ca772de25a69150ede66cc8789a64b2fbcd661164#rd",
          thumb_url: "29.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmU4uF3GjRb6NuRyRWafhZKs",
    content: {
      news_item: [
        {
          title: "Sale Alert // 近期促销汇总（6月9日）",
          author: "",
          digest: "",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000496&idx=1&sn=89ea30110a9d8d460fa46e08c5013860&chksm=6878b03a5f0f392c9e22d4881beb2bc634177d7f7cb90f0509dc4dc547bb188a2607d54062b6#rd",
          thumb_url: "28.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmZCixVu6VhO6AtRqW01wfOs",
    content: {
      news_item: [
        {
          title: "Sale Alert // 近期促销汇总（6月2日）",
          author: "",
          digest: "",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000491&idx=1&sn=367c0948c0ae85ce207bb4d9b53b661d&chksm=6878b0215f0f3937d57d80d92a286eabc4dd3b7873901b85009779fcefc76e1562c16474cd4b#rd",
          thumb_url: "27.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmd0Q5qUKAWhHK69gJofiOos",
    content: {
      news_item: [
        {
          title: "Sale Alert // 近期促销汇总（5月26日）",
          author: "",
          digest: "年中大促汇总 & 热门百货促销活动",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000448&idx=1&sn=d9b17d091bce7b2c70259a1b671642a1&chksm=6878b00a5f0f391c8a5e9ea070ff53664bf38cbfa26060945a0498f8fdcd83ab6c0ad2865fc1#rd",
          thumb_url: "26.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmcOWBn4Bh-XjrOrpKW4KvMM",
    content: {
      news_item: [
        {
          title: "Sale Alert // 近期促销汇总（5月19日）",
          author: "",
          digest:
            "年中大促开启Farfetch、SSENSE、Mytheresa、Cettire、Matchesfashion...",

          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000438&idx=1&sn=dfd43874f002931c2c38067efe2d6ff1&chksm=6878b07c5f0f396a986fc3d50cd504419c1033489dd35d2c6269471a9fec6837a858be67dfa9#rd",
          thumb_url: "25.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRma-kOWcMwQJpUk2a7lnzsR0",
    content: {
      news_item: [
        {
          title: "Sale Alert // 近期促销汇总（5月12日）",
          author: "",
          digest:
            "24S正价单品78折，Harvey Nichols全场9折，Farfetch年中促销开启...",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000429&idx=1&sn=451c60f42ac21a42af88a25887a87194&chksm=6878b0675f0f3971fbb19af3f80a2e9d3b69f2ef86efed2d31e9c6d902eaaca4128a8b71b3e2#rd",
          thumb_url: "24.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmSFODFy8VsLg859IXpC-fY8",
    content: {
      news_item: [
        {
          title: "rS Sale Alert // 近期促销汇总（5月8日）",
          author: "",
          digest:
            "Mytheresa 520满减活动，LVR母亲节8折，Cettire年中大促开启，SSENSE童装板块上线...",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000386&idx=1&sn=3338b51c7d3fd2f4559c7cc911a969fc&chksm=6878b0485f0f395e61774d46ccc6b32b5b2480bdd717d8efbd45845a721135feb85cc8a18d5e#rd",
          thumb_url: "23.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmfBoVxkfDu84hoUNJ6glYVo",
    content: {
      news_item: [
        {
          title: "rS Sale Alert // 近期促销汇总（4月28日）",
          author: "",
          digest:
            "Farfetch 55大促预告，Mytheresa女装低至7折，LVR全价85折，Revolve全场8折...",
          content_source_url:
            "https://docs.qq.com/sheet/DR2RlbFlYVGhXbWJ5?tab=BB08J2",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000364&idx=1&sn=6d32f44b933210eea993868ad9fee83c&chksm=6878b0a65f0f39b04049f9243faec0c9286849b3da13ffb5c3af42d204d90f5cd17e2b0c0f78#rd",
          thumb_url: "20.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmdW-tKmqrnPL5RKyaS2ORDU",
    content: {
      news_item: [
        {
          title: "rS Sale Alert // 近期促销汇总（4月21日）",
          author: "",
          digest:
            "SSENSE寄美国加拿大85折，Mytheresa全球免邮，LVR折扣单品额外优惠，LNCC低至75折...",
          content_source_url:
            "https://docs.qq.com/sheet/DR2RlbFlYVGhXbWJ5?tab=BB08J2",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000370&idx=1&sn=7dbd15685a4c0b66f4e7429df74351c0&chksm=6878b0b85f0f39ae19b920848dae03556da27cab25bc39b9ca82e3030c6bbda9ccd9afbe550e#rd",
          thumb_url: "21.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmU03nraxnz80aCjZFPF6iyw",
    content: {
      news_item: [
        {
          title: "rS Sale Alert // 近期促销汇总（4月14日）",
          author: "",
          digest:
            "Shopbop低至75折，Mytheresa满减200欧，Farfetch闪促最后一天，Sephora北美大促开启...",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000218&idx=1&sn=558be193c82a8776ae7420f835661cd6&chksm=6878b3105f0f3a06312b96b267d6149262fd33c491a745e7050be316b15b1e5444c0840a4a06#rd",
          thumb_url: "2.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmZ5yLEAXLPqoH3aqyJt7BNA",
    content: {
      news_item: [
        {
          title: "rS Sale Alert // 近期促销汇总 & 美国官网特卖精选（4月7日）",
          author: "",
          digest:
            "24S指定正价8折优惠，NAP早春85折促销，SSENSE春夏上新，MatchesFashion新人85折...",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000209&idx=1&sn=6c8e037ebdf270442e85a413c3d1d58a&chksm=6878b31b5f0f3a0db71a9eb3a5b6ba4da0dd40fed2cc475ce746992df434c10b249ab11adaa5#rd",
          thumb_url: "3.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmVufB5MOnpPnRL31-68UnZo",
    content: {
      news_item: [
        {
          title: "Apple.com上线啦！佣金率up to 10%",
          author: "",
          digest:
            "即刻开始生成Apple产品的rS链接，并邀请您的粉丝来购买这个最受喜爱的科技品牌吧~",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000177&idx=1&sn=4ce7ff64fb136e2679eb0187ec5491d4&chksm=6878b37b5f0f3a6d1aa775ac4831dc12a9d237800ef6a0cba4186f271f706537d8dfb4b5a6db#rd",
          thumb_url: "6.jpeg"
        }
      ]
    }
  }
];

export const STRATEGY_ARTICLES = [
  {
    media_id: "R9lAXiMOFA8wYez87YPRmWqitCjeOkfVwfIcrZG0SSc",
    content: {
      news_item: [
        {
          title:
            "品牌电商资讯｜全球TOP 100、英美新晋热门、海淘友好 & 转运最佳！",
          author: "",
          digest: "建议收藏🌟随时掌握消费动态！",
          content_source_url: "https://docs.qq.com/sheet/DR1luT1l4SnBsWVdt",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100001035&idx=1&sn=aaf8e90f75e2c3e3829c054326f7e27e&chksm=6878b7c15f0f3ed70a29b6eedfbde2c0cc313af8217bf3a5bb3edac8ee2fabb41586dcf93a18#rd",
          thumb_url: "35.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmVfts0wqXWb1YE3o9g-GnD0",
    content: {
      news_item: [
        {
          title: "独家策略 | 听说奥运过后，博主都转型了？",
          author: "",
          digest: "业余健身博主修炼手册，请查收~",
          content_source_url: "http://wechat.rewardstyle.com.cn/blog-list",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000894&idx=1&sn=b909b556cbd61f26372a2f8785b5874e&chksm=6878b6b45f0f3fa2f74a2b6a3b91842ed0db72b6887c04fe1175f2078226541483309ab9808c#rd",
          thumb_url: "34.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmaUHm-oAuO_R6yNuIWQSHec",
    content: {
      news_item: [
        {
          title:
            "rewardStyle独家 // 2021年中大促必备策略！为流量巅峰提前作准备",
          author: "",
          digest:
            "年中大促来啦~！我们为你整理好了干货满满的年中大促日程安排，以及热卖品清单等实用资讯，敬请查收~",
          content_source_url:
            "https://f.hubspotusercontent00.net/hubfs/6424709/2021%E5%B9%B4%E4%B8%AD%E5%A4%A7%E4%BF%83%E5%BF%85%E5%A4%87%E7%AD%96%E7%95%A5%EF%BC%81%E4%B8%BA%E6%B5%81%E9%87%8F%E5%B7%85%E5%B3%B0%E6%8F%90%E5%89%8D%E4%BD%9C%E5%87%86%E5%A4%87.pdf",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000379&idx=1&sn=cbb31cbf3aa0dfb1b4c1efc00bc0bc72&chksm=6878b0b15f0f39a774cf3334127ca6c68416fb240c22623fb73b0498a2d5c4bf653a9c9fc40d#rd",
          thumb_url: "22.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmVeRwQqE7WX_8aeJik7fJro",
    content: {
      news_item: [
        {
          title: "独家策略 | 海淘友好电商信息汇总",
          author: "",
          digest: "各家海淘电商的运费和税费政策都是怎样的？我们都给你整理好啦~",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000126&idx=1&sn=049d1e96160d4f001c5b1922e57e6568&chksm=6878b3b45f0f3aa24837ac1f48bf66738110447b316e66872f178f902bd35b9a740dc94b6e3e#rd",
          thumb_url: "10.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmafTVF2egllCDRpoFyiljho",
    content: {
      news_item: [
        {
          title: "独家策略 | 大家爱逛的电商还卖这些！？",
          author: "",
          digest:
            "其实大家常逛的电商网站还有很多被忽略的宝藏！今天我们就来一起挖掘好物，看能否为你近期的选题带来新鲜idea～",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000119&idx=1&sn=84761975562914c7558522ab1152eccc&chksm=6878b3bd5f0f3aab745498dfa7cdee448a8338b67637e367b04f33368d52aefab60402ce8849#rd",
          thumb_url: "11.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmf3OrzyqTYe0CJ7IFvnQGfc",
    content: {
      news_item: [
        {
          title: "独家策略 | 英美百货电商推荐清单",
          author: "",
          digest:
            "此前一些受疫情影响的英、美百货公司，现已经重新开放合作，可以继续做rS链接啦！",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000110&idx=1&sn=e4ea308aa64ebe67bafe9adabd5acb9d&chksm=6878b3a45f0f3ab2c77d1a3aca378f4f9bca813e65283e3d1dee8da8c91e61e450a9f6afacae#rd",
          thumb_url: "12.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmTlCwuo_Qumr073VDVXeInI",
    content: {
      news_item: [
        {
          title: "独家策略 | 春节 & 情人节策略特刊",
          author: "",
          digest:
            "在这样一个温情的节点，有些什么样应景又实用的内容适合与读者们分享？",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000153&idx=1&sn=2b53cb4f05c15e00db881201af503756&chksm=6878b3535f0f3a4557237db0305a8c102184e77fe4d059fbefd68f2f6a08dd59a79163c3f472#rd",
          thumb_url: "8.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmUtPwboP5TzhNUJo6lCMxnA",
    content: {
      news_item: [
        {
          title: "流行趋势 | 2021第一周，大家都在买什么？全球热卖单品出炉",
          author: "",
          digest: "中国、北美、英国地区销量TOP 5榜单来啦~",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000142&idx=1&sn=d2984c4daf85ced55f0f40e35cdaf48e&chksm=6878b3445f0f3a52c6492228498fbf9970c17388283d3363f260b88456b8d89b16407cf7b642#rd",
          thumb_url: "9.jpeg"
        }
      ]
    }
  }
];

export const NEWS_ARTICLE = [
  {
    media_id: "R9lAXiMOFA8wYez87YPRmVEOKe9Lg82XIUYCp3ydNag",
    content: {
      news_item: [
        {
          title: "遇见全新LTK：来自创始人的一封信",
          author: "",
          digest: "",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000483&idx=1&sn=9f5e6e5422c486443042ed80ecd967e9&chksm=6878b0295f0f393f727d50f8f58d266f7a3e06698da147d84c34f723b786cfa3acabb184b9ff#rd",
          thumb_url: "33.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmZCqZmQGxhG_HLA-dprXkfo",
    content: {
      news_item: [
        {
          title: "FAQs | 关于更名为LTK",
          author: "",
          digest: "",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000478&idx=1&sn=ba693849600fbc6bebd0df3284859f0a&chksm=6878b0145f0f390217edf5f4a6984679863dff83712bc37528d49fc2c695a36df192d3dee012#rd",
          thumb_url: "32.jpeg"
        }
      ]
    }
  },

  {
    media_id: "R9lAXiMOFA8wYez87YPRmVzxzdSjiCvd05jxxZBkGhA",
    content: {
      news_item: [
        {
          title: "This is rewardStyle",
          author: "",
          digest:
            "你可以轻松与全球5000+电商建立合作，并有机会结识来自世界各地，志同道合的内容创作者",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000167&idx=1&sn=218104f48c263e08d47085845a10ce36&chksm=6878b36d5f0f3a7b8e1734639724be27cebde04fb0711d5a75312ed422bbe98d19e52b35dd89#rd",
          thumb_url: "7.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmfDwSCAugoq5QhFwFdFWkYc",
    content: {
      news_item: [
        {
          title: "博主之书｜Amber Venz Box · 序言",
          author: "",
          digest: "LIKEtoKNOW.it: Stories From The Influencer Next Door",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000199&idx=1&sn=4e41ee49c41dbc003e49bb7dcc3fa5b3&chksm=6878b30d5f0f3a1bf6ca02ee0e8b69bffe0a64c72d7529b921d34512eba1fdfc9e3bf5ab47ac#rd",
          thumb_url: "4.jpeg"
        }
      ]
    }
  },
  {
    media_id: "R9lAXiMOFA8wYez87YPRmSQAZVU0elb0yY6JFyfjHiE",
    content: {
      news_item: [
        {
          title: "《女装日报 WWD》采访Amber：从rewardStyle看博主推介的力量",
          author: "",
          digest:
            "SimilarWeb提供的统计数据显示，个人影响力已经开始成为强大的流量驱动力",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000187&idx=1&sn=6ccb61d36b849a3c4be7c12ccfce3096&chksm=6878b3715f0f3a67f45b0122ff56919832a93b643698d20ee35aa1c08d25058d105bfaf58f6a#rd",
          thumb_url: "5.jpeg"
        }
      ]
    }
  }
];

export const BASIC_USE_ARTICLES = [
  {
    media_id: "R9lAXiMOFA8wYez87YPRmThIMzTY4UMI-V7BvauQwxk",
    content: {
      news_item: [
        {
          title: "LTK FAQ - 常见问题汇总",
          digest: "",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000025&idx=1&sn=d12027ef9af1f5a72504321f62fccd2a&chksm=6878b3d35f0f3ac55d83c0a4627ddb11527de206f9129844b9432bdeedcc7b3eeaa3bee06d7d#rd",
          thumb_url: "15.jpeg"
        },
        {
          title: "Link Ninja | 链接无法生成？",
          digest: "",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000025&idx=2&sn=adb1998fb315f126d25f6e0d96a7bb5a&chksm=6878b3d35f0f3ac5a790a2665c41614499a0749b617ccc129d67772e44de84b672780822a4be#rd",
          thumb_url: "16.jpeg"
        },
        {
          title: "链接问题 | 短链接格式有何区别？",
          digest: "",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000025&idx=3&sn=c6cdcd582111038c6edfe9cede260803&chksm=6878b3d35f0f3ac51d7bbb230edfb12489e516c43a527fb8d3944b849c0d888a801581ccc084#rd",
          thumb_url: "18.jpeg"
        },
        {
          title: "佣金收入｜如何查看我的收入？",
          digest: "",

          thumb_media_id: "R9lAXiMOFA8wYez87YPRmUcbKu2Nke63JicbUByELbc",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000025&idx=4&sn=85522369e63ea31412c5462455875f44&chksm=6878b3d35f0f3ac52fb04814c3f7679a1f5fd766c634b119def4619c881e6f9d97b33555da07#rd",
          thumb_url: "17.jpeg"
        },
        {
          title: "支付提现 | 有固定的支付时间吗？",
          digest:
            "【支付提现】Q: 我何时可以收到佣金收入？A: 每笔佣金在关闭后，会累积在您账户的'我的收益'页面中的'应付",
          url:
            "http://mp.weixin.qq.com/s?__biz=MzIyNTgxNDQzNw==&mid=100000025&idx=5&sn=7a38cd7c68128ec01c3f52d56852003d&chksm=6878b3d35f0f3ac55a08005dd6f6035f92bf49f00e652f3d98f47cb3d445410fcbbfbacee1c2#rd",
          thumb_url: "19.jpeg"
        }
      ]
    }
  }
];
